import * as React from "react";
import { Card, CardContent, Typography } from "@mui/material";

interface IHtmlReportPanelProp {
    title: string;
    children: React.ReactNode;
    height?: string;
    isPrinting?: boolean;
}

export const HtmlReportPanel = (props: IHtmlReportPanelProp) => {
    return (
        <Card
            variant="outlined"
            sx={{
                "height": props.height ?? "100%",
                "borderColor": props.isPrinting ? "transparent" : undefined,
            }}>
            <CardContent
                sx={{
                    "paddingTop": props.isPrinting ? 0 : undefined,
                    "paddingBottom": props.isPrinting ? 0 : undefined,
                    "&:last-child": {
                        paddingBottom: props.isPrinting ? 0 : undefined
                    }
                }}
            >
                <Typography variant="h5" component="div" margin="0 0 1rem 0">
                    {props.title}
                </Typography>
                {props.children}
            </CardContent>
        </Card>
    );
};
